let pendingRequests = [];
let visible = false;
let challenge = null;
const listeners = new Set();
const challengeReasons = new Set(["password_confirmation_required", "external_reauthentication_required", "admin_reauthentication_required"]);

function notify() {
    const state = { visible, pendingCount: pendingRequests.length, challenge };
    listeners.forEach((listener) => listener(state));
}

export function subscribeToRecentAuthentication(listener) {
    listeners.add(listener);
    listener({ visible, pendingCount: pendingRequests.length, challenge });

    return () => listeners.delete(listener);
}

export function isRecentAuthenticationChallengeReason(reason) {
    return challengeReasons.has(reason);
}

export function requestRecentAuthentication(config, requestedChallenge = null) {
    if (!config) {
        return Promise.reject(new Error("The sensitive request cannot be retried."));
    }

    const { cancelToken, signal, ...retryableConfig } = config;

    return new Promise((resolve, reject) => {
        pendingRequests.push({ config: retryableConfig, resolve, reject });
        visible = true;
        challenge = requestedChallenge;
        notify();
    });
}

export function retryPendingRequests(requester) {
    const requests = pendingRequests;
    pendingRequests = [];
    visible = false;
    challenge = null;
    notify();

    return Promise.all(
        requests.map(({ config, resolve, reject }) =>
            Promise.resolve()
                .then(() => requester({ ...config, __recentAuthRetried: true }))
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                })
        )
    );
}

export function cancelPendingRequests(error = new Error("Password confirmation was cancelled.")) {
    const requests = pendingRequests;
    pendingRequests = [];
    visible = false;
    challenge = null;
    notify();
    requests.forEach(({ reject }) => reject(error));
}
